<div class="main">
  <div class="button-container">
    <button mat-flat-button
      color="accent"
      class="generalBtn"
      (click)="customerClicked()">
      Ny kunde
    </button>
  </div>

  @if (!isHistory) {
    <div class="list-container">
      <lib-list-view [headerList]="headerList"
        #listView
        (rowClick)="customerClicked($event)"
        [extraBurgerMenuOptions]="extraBurgerMenuOptions">
      </lib-list-view>
    </div>
  }

  @if (isHistory) {
    <div class="list-container">
      <lib-list-view [headerList]="logHeaderList"
        #logListView
        [extraBurgerMenuOptions]="extraBurgerMenuOptions">
      </lib-list-view>
    </div>
  }
</div>
